// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5VxoHwb15M58RNfphJ9O"};